import React, { Component, ReactElement, ReactNode } from 'react';
import styled from 'styled-components';
import { p4Tokens } from '../../styles/themes/default/p4FluentTheme';

const FormContainerDiv = styled.div<Partial<React.CSSProperties>>`
  position: relative;
  height: ${(props) => props.height || '100%'};
  background-color: ${p4Tokens.colorNeutralBackground1};
  border: none;
  min-height: ${(props) => props.minHeight};
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding-bottom: ${(props) => props.paddingBottom || '0px'};
`;

type IFormContainerProps = {
  ignoreClickOutside?: boolean;
  paddingBottom?: string;
  'data-testid'?: string; //Optional, made available so non-connected forms have a space to inject a data-testid.
  children?: ReactNode | ReactElement | Array<ReactElement>;
};

export default class FormContainer extends Component<IFormContainerProps, { error: any; errorInfo: any }> {
  render() {
    return (
      <FormContainerDiv
        className={this.props.ignoreClickOutside ? 'ignore-react-onclickoutside' : undefined}
        paddingBottom={this.props.paddingBottom}
        data-testid={this.props['data-testid']}
      >
        {this.props.children}
      </FormContainerDiv>
    );
  }
}
